import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IClient from "../../models/IClient";
import { FormListBase, FormListBaseTab, FormListBaseGrid } from '../base';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import { Button } from 'devextreme-react';
import FormSysteme from '../../components/forms/form-systeme';

export default function GestionFacturationCompteurs() {
  const clientFormDataSource = useCustomDataSource<IClient, IClient>({ path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list" });
  const { selectedDataRow: selectedClient, mode,setMode, isFieldModifier, setIsFieldModifier } = clientFormDataSource;
  const typesDocuments = ["Aucun", "Imprimante", "Courriel", "Imprimante et courriel"];

  const documentOptions = useMemo(() => {
    return { items: typesDocuments, defaulValue: typesDocuments[0], layout: "horizontal" };
  }, []);
  
  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid dataSource={clientFormDataSource.dataSource}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false} />
        <Column key={"grid-col-adresse"} dataField={"adresse"} caption="Adresse" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseTab>
        <TabItem title="Informations">
          <div style={{ display: "flex" }}>
            <div style={{ width: "60%" }}>
              <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <GroupItem colCount={2}>
                  <SimpleItem key={"frm-produit-a-facturer"} dataField={"asdf"}>
                    <Label text={"Produit à facturer"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-facturation"} dataField={""} editorType={"dxDateBox"}>
                    <Label text={"Date de facturation"} />
                  </SimpleItem>
                </GroupItem>
                <SimpleItem key={"frm-document"} dataField={"document"} editorType={"dxRadioGroup"}
                  editorOptions={
                    documentOptions
                  } />
                <SimpleItem key={"frm-message-a-facturer"} dataField={"asdf"}>
                  <Label text={"Message à facturer"} />
                </SimpleItem>
              </Form>
            </div>
            <div style={{ width: "40%" }}>
              <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <SimpleItem key={"frm-b1"}>
                  <div style={{ position: "relative", float: "right" }}>
                    <span>
                      <Button text={"Rafraichir"} />
                    </span>
                    <span style={{ position: "relative", marginLeft: "1em" }}>
                      <Button text={"Facturer"} />
                    </span>
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-b2"}>
                  <div style={{ position: "relative", float: "right", top: "1.8em" }}>
                    <span>
                      <Button text={"Tout désélectionner"} />
                    </span>
                    <span style={{ position: "relative", marginLeft: "1em" }}>
                      <Button text={"Tout sélectionner"} />
                    </span>
                  </div>
                </SimpleItem>
              </Form>
            </div>
          </div>
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedClient || {} as IClient} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem caption={"Liste des compteurs"}>
              <GroupItem>
                <DataGrid showBorders={true} allowColumnResizing={true}>
                  <Column caption={"Unité"}  />
                  <Column caption={"Client"}  />
                  <Column caption={"Numéro compteur"}  />
                  <Column caption={"Date de lecture"}  />
                  <Column caption={"Ancienne valeur"}  />
                  <Column caption={"Valeur actuelle"}  />
                  <Column caption={"Valeur à facturer"}  />
                  <Column caption={"Total avant taxes"}  />
                  <Column caption={"Déjà facturer"}  />
                  <Column caption={"À facturer"}  />
                </DataGrid>
              </GroupItem>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedClient || {} as IClient} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}
